<template>
  <div class="form-group" :class="{ 'has-error': error }">
    <label :for="$attrs.id" :class="{ required }">
      <strong>{{ label }}</strong>
    </label>
    <select v-bind="$attrs" v-on="listeners" :value="value" class="form-control">
      <option v-if="placeholder" disabled selected>{{ placeholder }}</option>
      <option v-for="option in options" :key="option">{{ option }}</option>
    </select>
    <span v-show="error" class="help-block">{{ error }}</span>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      value: {
        type: String,
      },
      label: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default: [],
      },
      placeholder: {
        type: String,
        default: '',
      },
    },

    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: (e) => this.$emit('input', e.target.value),
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  label {
    font-size: 20px;
    &.required::after {
      content: '*';
      color: red;
    }
  }
</style>
